import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/lib/Button';

const classButtonInactive = 'btn btn-default close-modal btn-block';
import * as actions from '../../../actions/response';
import {converter} from '../../../helpers/converter';
import * as metricsActions from '../../../action-creators/metrics';

class ModalErrorRecording extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    // Set Metrics
    props.setMetricsEvent({
      type: 'executor',
      error: props.message,
    });
  }

  closeModal() {
    if(this.props.buttonCloseAction) {
      return this.props.buttonCloseAction();
    }
    this.props.closeModal("ErrorRecording");
  }

  onAccept(e, cb) {
    e.preventDefault();
    if (!cb) {
      return this.closeModal();
    }
    const scope = this;
    return cb(scope);
  }

  onClose(e, cb) {
    e.preventDefault();
    if (!cb) {
      return this.closeModal();
    }
    const scope = this;
    return cb(scope);
  }

  render() {
    return (
      <Modal show={true}>
        <Modal.Header>
          <Button className="close close-modal" onClick={ (e) => this.onClose(e, this.props.onClose)}>x</Button>
        </Modal.Header>
        <Modal.Body className='text-center error'>
          <i className="fa text-center fa-3x fa-times texto-blanco"></i>
          <b><p className='padding-top-2' style={{fontSize: "18px"}} dangerouslySetInnerHTML={
              {__html: this.props.titleBold }
            }></p></b>
            <p style={{fontSize: "16px"}} dangerouslySetInnerHTML={
              {__html: this.props.title }
            }></p><p style={{fontSize: "16px"}} dangerouslySetInnerHTML={
              {__html: this.props.msg }
            }></p>
        </Modal.Body>
        <Modal.Footer>
          <div className="footer-modal-button flex-end">
            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-12 padding-top-05">
              <Button
                className={ classButtonInactive }
                onClick={ (e) => this.onAccept(e, this.props.onAccept)}>
                {converter.convertApaUnicode(this.props.translations, 'registro_aceptar', 'Aceptar')}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    translations: state.translations,
    payload: state.metrics.payload,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
  setMetricsEvent(options) {
    dispatch(metricsActions.setMetricsEvent(options));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalErrorRecording);
